import { WebinarRepository } from '../repositories/webinarRepository';
import { Loader } from '../utils/loader';

export class UpcomingWebinarsShortcode {
	constructor() {
		const nonceElement = document.getElementById(
			'upcoming_webinars_shortcode_nonce'
		);
		this.nonce = nonceElement ? nonceElement.value : null;

		this.repository = new WebinarRepository(this.nonce);
		this.loader = new Loader();

		this.owlList = new Map();

		this.state = {
			nextMonthTimestamp:
				typeof UPCOMING_WEBINARS_SHORTCODE_CONFIG === 'undefined'
					? ''
					: UPCOMING_WEBINARS_SHORTCODE_CONFIG.nextMonthTimestamp,
			termName: '',
			canLoadMore: true,
		};

		this.owlConfig = {
			center: true,
			items: 1,
			loop: true,
			stagePadding: 48,
			margin: 18,
			nav: false,
			dots: true,
			autoplay: true,
			autoplayTimeout: 6000,
			smartSpeed: 1000,
			dragEndSpeed: 1000,
			autoplayHoverPause: false,
		};

		this.registerEventListeners();

		this.initOwl();
	}

	registerEventListeners() {
		window.addEventListener('resize', (e) => this.windowResizeHandler(e));

		const containerElement = document.getElementById(
			'upcoming-webinars-shortcode'
		);
		if (!containerElement) {
			return;
		}

		const seeMoreButtonElement = containerElement.querySelector(
			'.js-see-more-button'
		);
		if (seeMoreButtonElement) {
			seeMoreButtonElement.addEventListener('click', (e) =>
				this.seeMoreButtonClickHandler(e)
			);
		}

		const tagSearchForm = containerElement.querySelector('.tag-search');
		if (!tagSearchForm) {
			return;
		}

		tagSearchForm.addEventListener('submit', (e) =>
			this.tagSearchFormSubmitHandler(e)
		);

		const searchIcon = tagSearchForm.querySelector('.fa-search');
		if (searchIcon) {
			searchIcon.addEventListener('click', (e) =>
				this.searchIconClickHandler(e)
			);
		}

		const searchInput = tagSearchForm.querySelector('input[name=name]');
		if (searchInput) {
			searchInput.addEventListener('input', (e) =>
				this.searchInputHandler(e)
			);
		}
	}

	initOwl() {
		if (window.innerWidth < 769) {
			this.createCarousels();
			return;
		}

		const loaderElement = document.querySelector(
			'#upcoming-webinars-shortcode'
		);
		if (loaderElement) {
			this.loader.hide(jQuery(loaderElement));
		}
	}

	windowResizeHandler(e) {
		const target = e.target;

		const width = target.innerWidth;
		width < 769 ? this.createCarousels() : this.destroyCarousels();
	}

	tagSearchFormSubmitHandler(e) {
		e.preventDefault();

		this.loadMonthSection(true);

		document.activeElement.blur();
	}

	searchIconClickHandler(e) {
		const target = e.target;

		const form = target.closest('.tag-search');
		if (!form) {
			return;
		}

		form.requestSubmit();
	}

	searchInputHandler(e) {
		const target = e.target;
		const state = this.state;

		state.termName = target.value;
	}

	seeMoreButtonClickHandler(e) {
		const target = e.target;
		const state = this.state;

		if (!state.canLoadMore) {
			return;
		}

		state.canLoadMore = false;

		this.loadMonthSection();
	}

	loadMonthSection(isNewSearch = false) {
		const state = this.state;

		this.repository
			.getUpcomingWebinarsData({
				nextMonthTimestamp: state.nextMonthTimestamp,
				termName: state.termName,
				isNewSearch,
			})
			.then((response) => {
				const nextMonthTimestamp =
					response.data.nextMonthTimestamp.toString();

				const webinarCollection = response.data.webinarCollection;

				if (webinarCollection.amount===undefined) {
					this.removeSeeMoreButton();
				}

				state.canLoadMore = nextMonthTimestamp.length ? true : false;
				state.nextMonthTimestamp = nextMonthTimestamp;

				const containerElement = document.querySelector(
					'.upcoming-webinars-shortcode-sections-wrapper'
				);
				if (!containerElement) {
					return;
				}

				if (isNewSearch) {
					containerElement.innerHTML = '';
				}

				const template = document.createElement('template');
				template.innerHTML = response.data.html.trim();

				const sectionElement = template.content.firstChild;
				containerElement.appendChild(sectionElement);

				const gridElement = sectionElement.querySelector(
					'.upcoming-webinars-shortcode__webinar-grid'
				);
				if (gridElement) {
					this.createCarousel(gridElement);
				}
			});
	}

	removeSeeMoreButton() {
		const element = document.querySelector(
			'.upcoming-webinars-shortcode .js-see-more-button'
		);
		if (element) {
			element.remove();
		}
	}

	createCarousels() {
		const owlList = this.owlList;
		if (owlList.size) {
			return;
		}

		const sectionElements = document.getElementsByClassName(
			'upcoming-webinars-shortcode__webinar-grid'
		);
		Array.from(sectionElements).forEach((element, index) => {
			if (
				element.getElementsByClassName('upcoming-webinar-article')
					.length
			) {
				element.classList.add('owl-carousel');

				const $owl = jQuery(element).owlCarousel(this.owlConfig);
				$owl.on(
					'initialized.owl.carousel',
					this.owlInitiazliedCallback()
				);
				this.owlList.set(index, $owl);
			}
		});
	}

	createCarousel(gridElement) {
		if (
			!gridElement ||
			window.innerWidth > 768 ||
			!gridElement.getElementsByClassName('upcoming-webinar-article')
				.length
		) {
			return;
		}

		gridElement.classList.add('owl-carousel');

		const owlList = this.owlList;
		const index = owlList.size
			? parseInt(Array.from(owlList)[owlList.size - 1][0]) + 1
			: 0;

		owlList.set(index, jQuery(gridElement).owlCarousel(this.owlConfig));
	}

	destroyCarousels() {
		const owlList = this.owlList;
		const sectionElements = document.getElementsByClassName(
			'upcoming-webinars-shortcode__webinar-grid'
		);

		Array.from(sectionElements).forEach((element, index) => {
			element.classList.remove('owl-carousel');

			if (owlList.has(index)) {
				owlList.get(index).trigger('destroy.owl.carousel');
				owlList.delete(index);
			}
		});

		this.owlList = owlList;
	}

	owlInitiazliedCallback() {
		const loaderElement = document.querySelector(
			'#upcoming-webinars-shortcode'
		);
		if (loaderElement) {
			this.loader.hide(jQuery(loaderElement));
		}
	}
}